import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { apiRequest } from '../lib/api';

const RANK_CLASS = ['gold', 'silver', 'bronze'];

function LeaderboardGlobal() {
  const [scores, setScores] = useState([]);
  const [error, setError] = useState('');
  const [showAll, setShowAll] = useState(false);

  useEffect(() => {
    async function loadGlobal() {
      try {
        const payload = await apiRequest('/leaderboard/global?limit=10');
        setScores(payload.scores || []);
      } catch (err) {
        setError(err.message);
      }
    }
    loadGlobal();
  }, []);

  const visibleScores = showAll ? scores : scores.slice(0, 5);

  return (
    <section className="surface-panel p-3" aria-labelledby="global-board-title">
      <h2 className="panel-title" id="global-board-title">
        Top Players <small>All time</small>
      </h2>
      {error && <p className="text-danger mb-2">{error}</p>}
      {scores.length === 0 ? (
        <p className="empty-hint">No scores yet. Be the first on the board.</p>
      ) : (
        <ol className="board-list">
          {visibleScores.map((entry, idx) => (
            <li key={entry._id || `${entry.username}-${idx}`} className="board-row">
              <span className={`rank ${RANK_CLASS[idx] || ''}`}>{idx + 1}</span>
              <span className="board-name">{entry.username}</span>
              <span className="board-pts">
                {entry.score}
                <small>pts</small>
              </span>
            </li>
          ))}
        </ol>
      )}
      {scores.length > 5 && (
        <Button variant="link" size="sm" className="px-0 mt-2" onClick={() => setShowAll((prev) => !prev)}>
          {showAll ? 'Show fewer' : `Show all ${scores.length}`}
        </Button>
      )}
    </section>
  );
}

export default LeaderboardGlobal;
